import React, { useEffect } from "react";
import HeroSection from "../components/Home/HeroSection";
import TrainingShowcaseSection from "../components/Home/TrainingShowcaseSection";
import TrainingFAQ from "../components/Home/TrainingFAQ";
import StrategicPartnersSection from "../components/Home/StrategicPartnersSection";
import HomeMotivationBanner from "../components/Home/HomeMotivationBanner";
import RegisterInviteSection from "../components/Home/RegisterInviteSection";
import GymFeaturesSection from "../components/Home/GymFeaturesSection"
import PlansSection from "../components/Home/PlanSection";
 import BlackDividerBottom from "../components/SectionDivider/BlackDividerBottom"
import BlackDividerTop from "../components/SectionDivider/BlackDividerTop"

function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <HeroSection />
      <GymFeaturesSection />
      <BlackDividerBottom />
      <TrainingShowcaseSection />
      <BlackDividerTop />
      <RegisterInviteSection />
      <PlansSection />
      <TrainingFAQ />
      <HomeMotivationBanner />
      <StrategicPartnersSection />
    </div>
  );
}

export default Home;